/*
 * @fileTile: 
 * @Description: 
 * @Autor: zsf
 * @Date: 2022-09-03 11:47:17
 * @LastEditTime: 2024-01-26 12:16:16
 */
const getters = {
  currentPage: state => state.transport.currentPage,
  transportInfo: state => state.transport.transportInfo,
  isUseOilTemp: state => state.fee.isUseOilTemp,
  isUseETCTemp: state => state.fee.isUseETCTemp,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js